import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import reduxConfig from '../../../store/config';
import { Mixer, MixerService } from './mixers.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/mixers');

export const getMixersList = actionCreator.async<{}, Mixer[]>('GET_MIXERS_LIST');
export const getMixerDetailById = actionCreator.async<{}, [Mixer, MixerService[]]>('GET_MIXERS_DETAIL_BY_ID');
export const createMixer = actionCreator.async<FormName, Mixer>('CREATE_MIXER');
export const editMixer = actionCreator.async<{ isRedirecting: boolean; formName: FormName }, Mixer>('EDIT_MIXER');
export const deleteMixer = actionCreator.async<FormName, string>('DELETE_MIXER');
export const downloadGateway = actionCreator.async<{}, unknown>('DOWNLOAD_GATEWAY');
export const callMixerStatus = actionCreator.async<{ id: string; formName: FormName }, {}>('CALL_MIXER_STATUS');
export const getMixerStatus = actionCreator.async<string, {}>('GET_MIXER_STATUS');
